import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllJenjang } from 'src/redux/slices/jenjang';
import { getAllKelas, getKelasFase } from 'src/redux/slices/kelas';
import { getTranslations } from 'src/redux/slices/translation';

import { getSemester, getSemesterAktif } from 'src/redux/slices/semester';
import {
  getAllTahunAjaran,
  getTahunAjaranAktif,
} from 'src/redux/slices/tahun_ajaran';

import { getPerusahaan } from 'src/redux/slices/perusahaan';

// redux
import { getInitialize } from '../../redux/slices/auth';
// ----------------------------------------------------------------------

JwtProvider.propTypes = {
  children: PropTypes.node,
};

export default function JwtProvider({ children }) {
  const dispatch = useDispatch();
  const chooseUnit = useSelector((state) => state.jenjang.chooseJenjang);

  useEffect(() => {
    dispatch(getInitialize());
    dispatch(getTranslations());
    dispatch(getAllJenjang());
    dispatch(getAllKelas());
    dispatch(getKelasFase());
    if (chooseUnit) {
      dispatch(getAllTahunAjaran(chooseUnit.unit_id, chooseUnit.company_id));
      // dispatch(getTahunAjaranAktif(chooseUnit.unit_id, chooseUnit.company_id));
      dispatch(getSemester(chooseUnit.unit_id, chooseUnit.company_id));
      // dispatch(getSemesterAktif(chooseUnit.unit_id, chooseUnit.company_id));
      dispatch(getPerusahaan(chooseUnit?.company_id));
    }
  }, [dispatch]);

  return <>{children}</>;
}
